import { gql } from '@apollo/client';

export const GET_COUNTRIES = gql`
  query GET_COUNTRIES {
    getCountries {
      id
      name
    }
  }
`;
